<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import Label from '$provider/constants/Label';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { onMount } from 'svelte';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  let selectedState = $state<string | undefined>(undefined);
  let stateLabel = $state<string | undefined>(undefined);

  onMount(() => {
    selectedState = alert?.props?.state;
    stateLabel = alert.props?.list?.find((item: any) => item.id === selectedState)?.label || '';
  });

  const onClickState = (detail: CommonList): void => {
    selectedState = detail.id;
    stateLabel = detail.label;
    onevent?.({
      type: 'change-state',
      data: { key: alert.key, type: detail.id }
    });
  };

  const onStateInputCleared = (): void => {
    if (!selectedState) return;
    selectedState = '';
    stateLabel = '';
    onevent?.({ type: 'clear-state', data: { key: alert.key } });
  };
</script>

<AlertView type={ListAlertType.StateChange} key={Label.ChangeTo} icon="icon-corner-down-right">
  {#snippet value()}
    <div class="state-list">
      <AutoComplete
        name="state"
        list={alert.props?.list || []}
        placeholder="Search State"
        value={stateLabel}
        onclick={onClickState}
        oncleared={onStateInputCleared}
      />
    </div>
  {/snippet}
</AlertView>

<style>
  .state-list {
    width: 400px;
    padding: 4px 16px;
  }
</style>
